import { useState, useEffect } from 'react'
import { Clock } from 'lucide-react'
import Card from '../components/Card'

const timeUnits = {
  milliseconds: { label: 'Milliseconds', toSeconds: 0.001 },
  seconds: { label: 'Seconds', toSeconds: 1 },
  minutes: { label: 'Minutes', toSeconds: 60 },
  hours: { label: 'Hours', toSeconds: 3600 },
  days: { label: 'Days', toSeconds: 86400 },
  weeks: { label: 'Weeks', toSeconds: 604800 },
  months: { label: 'Months', toSeconds: 2592000 },
  years: { label: 'Years', toSeconds: 31536000 }
}

export default function TimeConverter() {
  const [fromValue, setFromValue] = useState('')
  const [fromUnit, setFromUnit] = useState('hours')
  const [results, setResults] = useState({})

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setResults({})
      return
    }

    const value = parseFloat(fromValue)
    const fromSeconds = value * timeUnits[fromUnit].toSeconds
    const converted = {}

    Object.keys(timeUnits).forEach(unit => {
      if (unit !== fromUnit) {
        converted[unit] = fromSeconds / timeUnits[unit].toSeconds
      }
    })

    setResults(converted)
  }

  useEffect(() => {
    convert()
  }, [fromValue, fromUnit])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-3">From:</label>
              <div className="flex gap-3">
                <input
                  type="number"
                  value={fromValue}
                  onChange={(e) => setFromValue(e.target.value)}
                  className="input flex-1"
                  placeholder="Enter value"
                  step="any"
                />
                <select
                  value={fromUnit}
                  onChange={(e) => setFromUnit(e.target.value)}
                  className="input w-40"
                >
                  {Object.entries(timeUnits).map(([key, unit]) => (
                    <option key={key} value={key}>{unit.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      {Object.keys(results).length > 0 && (
        <Card>
          <Card.Body>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Converted Values:</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {Object.entries(results).map(([unit, value]) => (
                <div key={unit} className="bg-gray-50 rounded-lg p-4">
                  <div className="text-sm text-gray-600 mb-1">{timeUnits[unit].label}</div>
                  <div className="text-xl font-bold text-orange-600">
                    {value.toFixed(6).replace(/\.?0+$/, '')}
                  </div>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}

      {Object.keys(results).length === 0 && (
        <Card>
          <Card.Body className="text-center py-12">
            <Clock className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Enter a time value to see conversions</p>
          </Card.Body>
        </Card>
      )}
    </div>
  )
}

